import { reduce } from "et3-type-guards";
import { startCase, camelCase } from "lodash";
import getUserAdvancedStore from "../../../../../../stores/user-store/advanced-store";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import UserDeactivationCounter from "./UserDeactivationCounter";
import UserTester from "./UserTester";
import UnderCSRInvestigation from "./UnderCSRInvestigation";
import UserReported from "./UserReported";
import UserSilentBanned from "./UserSilentBanned";

const UserStatus = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const advancedStore = getUserAdvancedStore();
  const userId = advancedStore.currentUserId.get();
  const data = advancedStore.userData.get(userId);
  const userStatus = reduce(() => data.status, "");
  const deactivationCounter = reduce(() => data.deactivationCounter, 0);
  const isUserDeactivated = userStatus === "deactivated";
  const userStatusColor =
    userStatus === "active" ? colors.all.green : colors.all.red;
  const userStatusUpperFirst = startCase(camelCase(userStatus));

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={322}
      height={250}
      fDirection="column"
      alignItems="center"
      justifyContent="center"
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={222}
        height={36}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={userStatusColor}
        style={{
          borderRadius: 20
        }}
        onClick={() => {}}
      >
        <Et3Margin top={20} right={0} bottom={0} left={0} />
        <Et3Text
          text={`${userStatusUpperFirst}`}
          fontFamily="BOLD"
          fontSize={15}
          color={colors.all.white}
          isSpan={true}
          style={{}}
        />
        <Et3Margin top={0} right={10} bottom={0} left={0} />
        <UserDeactivationCounter
          isUserDeactivated={isUserDeactivated}
          counter={deactivationCounter}
        />
      </ET3Div>
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <UnderCSRInvestigation />
      <UserReported />
      <UserTester />
      <Et3Margin top={10} bottom={0} left={0} right={0} />
      <UserSilentBanned />
    </ET3Div>
  );
});
export default UserStatus;
